import React from "react";

import closeBtn from "./assets/images/close.svg";
import "./assets/css/style.css";

function Tooltip() {
  function closeTooltip(e: any) {
    e.preventDefault();
    e.target.parentNode.parentNode.classList.remove("tooltip--open");
  }
  return (
    <div className="tooltip tooltip--open">
      <button onClick={closeTooltip} className="tooltip__close close">
        <img src={closeBtn} alt="Close" />
      </button>
      <h3 className="tooltip__title">TIP</h3>
      <p className="tooltip__text">Don't forget to activate this user.</p>
      <div className="tooltip__triangle"></div>
    </div>
  );
}

export default Tooltip;
